import { getDateWithCache } from '@/utils/dates';

export const timeFormatForEmails = (timestamp: number | string, language: string, timezone: string) => {
  const cached = getDateWithCache(timestamp);
  return cached.toLocaleString(language, {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
    timeZoneName: 'short',
  });
};
